import axios from "../../service";
import fn from "@/helpers/utility";
import { WebHookService } from '../resources'
export const state = {
  storeSelect: {},
  keyAuth: {
    key: "open_api_flag",
    keyAdvance: "advanced_open_api_flag"
  }
};

export const mutations = {
  SET_VALUE_WEBHOOK(state, newValue) {
    state.storeSelect = newValue;
    // if (newValue.length == 0) {
    //   state.partnerListOption.report = newValue;
    //   state.partnerListOption.total = newValue.length;
    // } else {
    //   state.partnerListOption = newValue;
    // }
  }
};

export const getters = {
  PermissionFlag(state) {
    return fn.PermissionFlag(state.keyAuth.keyAdvance);
  }
};

export const actions = {
  async generateToken({ commit }, data) {
    try {
      let resp = await WebHookService.apiGetgenerateToken()
      return { status: true, ...resp };
    } catch (err) {
      console.error(err.message, "Error");
      return { status: false, err: err };
    }
  },

  async getListWebHook({ commit }, data) {
    try {
      let resp = await WebHookService.apiGetListWebHook(data || {})
      return { status: true, ...resp };

      
    } catch (err) {
      console.error(err.message, "Error");
      return { status: false, err: err };
    }
  },
  async getListWebHookById({ commit }, id) {
    try {
      let resp = await WebHookService.apiGetListWebHookById(id)
      return { status: true, data: resp };
    } catch (err) {
      console.error(err.message, "Error");
      return { status: false, err: err };
    }
  },

  async createWebHook({ commit }, data) {
    try {
      let resp = await WebHookService.apiCreateWebHook(data)
      return { status: true, ...resp }
    } catch (err) {
      console.error(err.message, "Error");
      return { status: false, err: err };
    }
  },

  async updateWebHook({ commit }, data) {
    try {
      let resp = await WebHookService.apiEditupdateWebHook(data)
      return { status: true, ...resp };
    } catch (err) {
      console.error(err.message, "Error");
      return { status: false, err: err };
    }
  },

  async deleteWebHook({ commit }, id) {
    try {
      let resp = await WebHookService.apiDeleteWebHook(id)
      return { status: true, ...resp };
    } catch (err) {
      console.error(err.message, "Error");
      return { status: false, err: err };
    }
  }
};
